import ActionDispatcherService from '../common/actions/core/action-dispatcher.service';
import {ITimeoutService,IWindowService,IIntervalService} from 'angular';
import {UserResponse} from '../common/services/user/user.model';
import UserService from '../common/services/user/user.service';
import {OpenUserRegistrationAction} from './family-plan-user-registration-dialog/family-plan-user-registration-dialog.action';
import FamilyPlanService from '../family-plan/famil-plan.service';

import 'jquery-ui/ui/widgets/autocomplete';
import { OpenAboutDialogAction } from './family-plan-about-dialog/family-plan-about-dialog.action';
import { FamilyPlanTypes } from '../common/services/package/package.model';
const injector = angular.injector(['ng'], true);

/* @ngInject */
export default class familPlanController {
  public user: UserResponse;
  public approveSaveCard: boolean = false;

  public emailCode: string;
  public isEmailVerified: boolean = false;
  public emailOtpSent: boolean = false;
  public isReqSend: boolean = false;
  public otpErrorMessage: any;
  public time: string = '03:00';
  public resendDisabled: boolean = true;
  public emailForOtp: string = '';

  private familyPlanGetUserInfoForm: any;
  private addressChange: any;
  private selectedAddress:any;
  private today = new Date();
  private currentYear = this.today.getFullYear();
  private minYear = new Date(this.today.setFullYear(this.today.getFullYear() - 130)).getFullYear();
  private years = [];
  private type: FamilyPlanTypes;
  private timer: any = null;


  constructor(
    private userService: UserService,
    private $element,
    private $state,
    private $timeout: ITimeoutService,
    private $interval: IIntervalService,
    private actionDispatcher: ActionDispatcherService,
    private familyPlanService: FamilyPlanService
  ) {

  }

  public $onInit() {
    this.type = this.$state.current.name.includes('duo') ? FamilyPlanTypes.DUO : FamilyPlanTypes.FAMILY;
    this.loadVerifiedEmailFromSession();
    this.userService.getUserInfo().then(user => {
      this.user = user;
      this.familyPlanService.getFamilyPlanInfo(this.type).then(familyMemberInfo => {
        if(familyMemberInfo.masterMember.userId == this.user.id){
          this.$state.go('familyPlanInfo');
        } else{
          this.$state.go('familyPlanMemberInfo');
        }
      });
    });
     angular.element(document).ready(() => {
      if(this.type == FamilyPlanTypes.FAMILY) {
        this.addressAutoComplete();
      }
      this.checkedValid();
    });
    for (var i = this.currentYear; i >= this.minYear; i--) {
      this.years.push(i);
    }
  }

  public checkedValid() {
    this.familyPlanGetUserInfoForm = this.$element.find("#familyPlanGetUserInfoForm");
    const savedButton = angular.element('#fp-saved-infos');
    this.familyPlanGetUserInfoForm.on('change', function (event) {
      const evntTrgt = event.currentTarget;
      if (evntTrgt.checkValidity()) {
        savedButton.removeAttr('disabled');
      } else {
        savedButton.attr('disabled', 'disabled');
      }
    });
  }

  public addressAutoComplete(){
    this.addressChange = angular.element('#address');
    var self = this;
    self.autoComplete(self, '')
    this.addressChange.bind('paste keyup', function (evnt)  {
      self.$timeout(() => {
        let addressinputval =  evnt.target.value;
        self.autoComplete(self, addressinputval) , 500
      });

  });
  };

  private autoComplete(self: this, addressinputval: any) {
    return $("#address").autocomplete({
      source: function (request, response) {
        self.familyPlanService.addressAutoComplete(addressinputval).then(result => {
          response(result);
        });
      },
      create: function () {
      },
      select: function (event, ui) {
        let address = [];
        for (let i = 0; i < 16; i++) {
          address.push(ui.item[i]);
        }

        self.selectedAddress = address;
        $("#address").val(ui.item[0]);
        if (self.$element.find('#familyPlanGetUserInfoForm')[0].checkValidity()) {
          angular.element('#fp-saved-infos').removeAttr('disabled');
        }
        return false;

      }
    })
      .data("ui-autocomplete")._renderItem = function (ul, item) {
        return $("<li>")
          .append("<div class='crspointer'>" + item[0] + "</div>")
          .appendTo(ul);
      };
  }

  public sendEmailOtp() {
    const email = this.familyPlanGetUserInfoForm[0].elements.email.value;
    if (!this.checkedEmailValid(email)) {
      return;
    }
    this.emailForOtp = email;
    this.isReqSend = true;
    this.otpErrorMessage = null;
    this.familyPlanService.sendEmail(email, this.type).then(() => {
      this.isReqSend = false;
      this.emailOtpSent = true;
      this.startTimer();
    }, (error) => {
      this.isReqSend = false;
      this.otpErrorMessage = 'familyPlan.otp.sendError';
    });
  }

  public validateEmailOtp() {
    const email = this.emailForOtp || this.familyPlanGetUserInfoForm[0].elements.email.value;
    if (!this.emailCode || this.emailCode.trim().length === 0) {
      this.otpErrorMessage = 'familyPlan.otp.empty';
      return;
    }
    this.isReqSend = true;
    this.otpErrorMessage = null;
    this.familyPlanService.validateEmail(email, this.emailCode, this.type).then(() => {
      this.isReqSend = false;
      this.isEmailVerified = true;
      this.emailOtpSent = false;
      this.saveVerifiedEmailToSession(email);
      this.resetTimer();
    }, (error) => {
      this.isReqSend = false;
      this.otpErrorMessage = 'familyPlan.otp.sendError';
      this.emailCode = '';
      this.emailOtpSent = false;
      this.resetTimer();
    });
  }

  public onResendEmailOtp() {
    this.resetTimer();
    this.emailCode = '';
    const email = this.emailForOtp;
    if (!email || !this.checkedEmailValid(email)) {
      this.otpErrorMessage = 'familyPlan.otp.invalidEmail';
      return;
    }
    this.isReqSend = true;
    this.otpErrorMessage = null;
    this.familyPlanService.sendEmail(email, this.type).then(() => {
      this.isReqSend = false;
      this.emailOtpSent = true;
      this.startTimer();
    }, (error) => {
      this.isReqSend = false;
      this.otpErrorMessage = 'familyPlan.otp.sendError';
    });
  }

  public onEmailChange() {
    const currentEmail = (this.user && this.user.email) ? this.user.email : '';
    const verifiedEmail = this.getVerifiedEmailFromSession();

    if (currentEmail && verifiedEmail && currentEmail === verifiedEmail) {
      this.isEmailVerified = true;
      this.emailForOtp = currentEmail;
      this.emailOtpSent = false;
      this.emailCode = '';
      this.otpErrorMessage = null;
      this.resetTimer();
    } else if (this.isEmailVerified || this.emailOtpSent) {
      this.isEmailVerified = false;
      this.emailOtpSent = false;
      this.emailCode = '';
      this.emailForOtp = '';
      this.otpErrorMessage = null;
      this.resetTimer();
    }
  }

  private startTimer() {
    const countDownDate = new Date().getTime() + 3 * 60 * 1000;
    this.resendDisabled = true;
    this.time = '03:00';
    this.timer = this.$interval(() => {
      const now = new Date().getTime();
      const distance = countDownDate - now;
      const minutes = Math.floor((distance % (1000*60*60)) / (1000*60));
      const seconds = Math.floor((distance % (1000*60)) / 1000);
      if (distance < 0) {
        this.resendDisabled = false;
        this.$interval.cancel(this.timer);
        return;
      }
      this.time = (minutes < 10 ? '0' : '') + minutes + ':' + (seconds > 9 ? seconds : '0' + seconds);
    }, 1000);
  }

  private resetTimer() {
    if (angular.isDefined(this.timer)) {
      this.$interval.cancel(this.timer);
    }
    this.time = '03:00';
    this.resendDisabled = true;
  }

  private loadVerifiedEmailFromSession() {
    const verifiedEmail = this.getVerifiedEmailFromSession();
    if (verifiedEmail) {
      this.emailForOtp = verifiedEmail;
      this.isEmailVerified = true;
      this.emailOtpSent = false;
      if (this.user) {
        this.user.email = verifiedEmail;
      }
    }
  }

  private saveVerifiedEmailToSession(email: string) {
    const baseKey = 'verified_emails';
    const encodedKey = btoa(encodeURIComponent(baseKey));
    const existingData = this.getVerifiedEmailsFromSession();
    if (existingData.indexOf(email) === -1) {
      existingData.push(email);
    }
    const jsonData = JSON.stringify(existingData);
    const encoded = encodeURIComponent(jsonData);
    sessionStorage.setItem(encodedKey, btoa(encoded));
  }

  private getVerifiedEmailsFromSession(): string[] {
    const baseKey = 'verified_emails';
    const encodedKey = btoa(encodeURIComponent(baseKey));
    const item = sessionStorage.getItem(encodedKey);
    if (!item) {
      return [];
    }
    try {
      const decoded = decodeURIComponent(atob(item));
      return JSON.parse(decoded);
    } catch (e) {
      return [];
    }
  }

  private getVerifiedEmailFromSession(): string | null {
    const baseKey = 'verified_emails';
    const encodedKey = btoa(encodeURIComponent(baseKey));
    const item = sessionStorage.getItem(encodedKey);
    if (!item) {
      return null;
    }
    try {
      const decoded = decodeURIComponent(atob(item));
      const emails = JSON.parse(decoded);
      return (this.user && this.user.email && emails.indexOf(this.user.email) !== -1) ? this.user.email : null;
    } catch (e) {
      return null;
    }
  }

  public checkedEmailValid(email:any): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  public saveInfo(form: any) {
    if (form.$valid == true && this.isEmailVerified) {
      this.otpErrorMessage = null;
      const daylVal = this.familyPlanGetUserInfoForm[0].elements.day.value;
      const monthlVal = this.familyPlanGetUserInfoForm[0].elements.month.value;
      const yearlVal = this.familyPlanGetUserInfoForm[0].elements.year.value;
      const emailVal = this.user.email || this.emailForOtp;
      const strBirthDate = daylVal + monthlVal + yearlVal;

      this.familyPlanService.saveFamilyInfo(strBirthDate, emailVal, this.selectedAddress, this.type).then(result => {
        if(result.success){
          this.actionDispatcher.dispatch(
            new OpenUserRegistrationAction(this.type)
          );
        } else{
          //TODO show error
        }
      });
    } else if (!form.$valid || !this.isEmailVerified) {
      if (!this.isEmailVerified) {
        this.otpErrorMessage = 'familyPlan.otp.pleaseVerify';
      }
    }
  }

  public onAbout(){
    this.actionDispatcher.dispatch(new OpenAboutDialogAction(this.type));
  }

  public isDuoPackage() {
    return this.type == FamilyPlanTypes.DUO;
  }

}



// WEBPACK FOOTER //
// ./src/app/family-plan/family-plan.controller.ts